import * as Yup from 'yup'

export const personChangeStatusSchema = Yup.object().shape({
  status: Yup.number().typeError('Selecione um status').nullable().required('Selecione um status'),
  observation: Yup.string().when('status', {
    is: 3,
    then: (schema) =>
      schema.required('Insira uma observação').min(5, 'Digite pelo menos 5 caracteres'),
    otherwise: (schema) => schema.notRequired(),
  }),
})
